<template>
  <div class="layout-detail-two-columns content-wrapper bg-white dark:bg-darkblue-900 flex flex-col w-full relative">
    <slot name="header" />
    <main ref="main" class="content flex flex-col flex-auto overflow-y-auto lg:overflow-y-hidden w-full">
      <div
        :class="{'lg:max-w-twocol ':!toEdge}" :style="{ '--left-height': mainHeight }"
        class="w-full flex flex-col lg:flex-row lg:mr-auto flex-grow">
        <div class="left-col px-4 lg:px-10 w-full md:w-11.5/12 lg:max-w-detailinvoice overflow-y-hidden lg:overflow-y-auto lg:h-[var(--left-height)]">
          <slot name="LeftCol" />
        </div>
        <div class="right-col w-full dark:bg-darkblue-800 dark:text-darkblue-200">
          <slot name="RightCol"/>
        </div>
      </div>
    </main>
    <slot name="layout-extend" />
  </div>
</template>

<script>
export default {
  name: 'layout-detail-two-columns',
  props: {
    toEdge: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainHeight: 'auto',
      resizeObserver: null
    }
  },
  mounted () {
    const mainElement = this.$refs.main
    if (mainElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMainHeight()
      })
      this.resizeObserver.observe(mainElement)
    }
  },
  methods: {
    updateMainHeight: function () {
      const mainElement = this.$refs.main
      if (mainElement) {
        this.mainHeight = getComputedStyle(mainElement).height
      }
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
}
</script>
<style>
@property --left-height {
  syntax: "<length-percentage>|auto";
  inherits: true;
  initial-value: auto;
}
</style>
